<template>
  <div class="login-wrap">
    <div class="left"></div>
    <div class="right">
      <div class="loginBox">
        <div class="loginTitle">欢迎使用煜杭健康线上接诊平台</div>
        <div class="ms-login">
          <div v-if="loginFormFLag" class="QRcodeBox">
            <div>请使用医网信App扫描下方二维码登录</div>
            <div>
              <img :src="QR_code" alt="" @click="getQR_code" v-loading="QR_code_loading"/>
            </div>
          </div>
          <el-form v-else :model="loginForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
            <el-form-item prop="username">
              <el-input v-model="loginForm.username" placeholder="用户名"
                        @keyup.enter.native="LoginButton()"></el-input>
            </el-form-item>
            <el-form-item prop="password" class="passwordBox">
              <el-input :type="inputType" placeholder="密码" v-model="loginForm.password"
                        @keyup.enter.native="LoginButton()"></el-input>
              <i class="iconfont icon-passwordshown" v-if="showPassword == false" @click="changInputType"></i><i
                class="iconfont icon-passwordhidden" v-else @click="changInputType"></i>
            </el-form-item>

            <el-form-item prop="code" class="captchaInput" style="margin-bottom: 20px">
              <el-input placeholder="请输入验证码" v-model="loginForm.code"
                        @keyup.enter.native="LoginButton()"></el-input>
              <img :src="captchaImg" alt="点击刷新验证码" @click="captchaLoad" class="captcha"/>
            </el-form-item>

            <div class="login-btn">
              <el-button class="loginButton" @keyup.enter.native="LoginButton()" @click="LoginButton()"
                         v-loading="loginLoadingFlag">登录
              </el-button>
            </div>
          </el-form>
          <div class="changeButton">
            <el-button type="text" @click="changeLoginButton">{{
                buttonName
              }}
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="outFlag" width="30%" :show-close="false" class="tipsMsgBox">
      <span style=" font-size: 20px; font-weight: 800">
        {{ errorMsg }}
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {encrypt} from "@/utils/gmCrypt";
import {CA_Login, caFlag, getCA_Token, getCaptcha, Login} from "../../api/index";
import store from "@/store/store";
import {socketInit} from "@/utils/socket";

export default {
  data: function () {
    return {
      checked: false,
      loginForm: {
        username: "",
        password: "",
        code: "",
        uuid: "",
      },
      captchaImg: "",
      rules: {
        username: [
          {required: true, message: "请输入用户名", trigger: "blur"},
        ],
        password: [{required: true, message: "请输入密码", trigger: "blur"}],
        code: [{required: true, message: "请输入验证码", trigger: "blur"}],
      },
      loginLoadingFlag: false,
      changePasswordForm: false,
      changePasswordList: {
        id: "",
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      loginFormFLag: true, //true为ca登录，false为账号密码登录
      buttonName: "切换为账号密码登录=>",
      QR_code: "",
      outFlag: false,
      errorMsg: "",
      QR_code_loading: true,
      requestId: "",
      CA_Login_timer: null,
      getCA_Token_timer: null,
      showPassword: false,
      inputType: "password",
    };
  },
  methods: {
    getCaFlag() {
      caFlag().then((res) => {
        if (res.code === 0) {
          this.loginFormFLag = res.data;
          localStorage.setItem("caFlag", res.data);
          if (this.loginFormFLag) {
            this.buttonName = "切换为账号密码登录=>";
            this.getQR_code();
            this.get_CA_Token();
          } else {
            clearTimeout(this.CA_Login_timer);
            clearInterval(this.getCA_Token_timer);
            this.buttonName = "切换为医网信登录=>";
            this.captchaLoad()
          }
        } else {
          this.outFlag = true;
          this.errorMsg = res.msg;
          setTimeout(() => {
            this.outFlag = false;
          }, 3000);
        }
      });
    },
    getQR_code() {
      let postData = {};
      this.QR_code_loading = true;
      CA_Login(postData).then((data) => {
        if (data.code == 0) {
          this.QR_code = "data:image/png;base64," + data.data.imgBase64;
          this.get_CA_Token();
          clearTimeout(this.CA_Login_timer);
          this.QR_code_loading = false;
          this.CA_Login_timer = setTimeout(() => {
            clearInterval(this.getCA_Token_timer);
          }, data.data.time * 1000);
          this.requestId = data.data.requestId;
        } else {
          this.outFlag = true;
          this.errorMsg = data.msg;
          this.QR_code_loading = false;
          setTimeout(() => {
            this.outFlag = false;
          }, 3000);
        }
      });
    },
    get_CA_Token() {
      clearInterval(this.getCA_Token_timer);
      this.getCA_Token_timer = setInterval(() => {
        let postData = {
          requestId: this.requestId,
        };
        getCA_Token(postData).then((data) => {
          if (data.code == 0) {
            if (data.data) {
              localStorage.setItem("token", data.data.token);
              socketInit();
              localStorage.setItem("doctor", JSON.stringify(data.data.doctor));
              localStorage.setItem("doctorEmployee", data.data.doctor.code);
              localStorage.setItem("doctorName", data.data.doctor.name);
              localStorage.setItem("doctorType", data.data.doctor.type);
              localStorage.setItem("hospitalCode", data.data.doctor.hospitalCode);
              localStorage.setItem(
                  "permissions",
                  JSON.stringify(data.data.permissions)
              );
              store.commit("SET_DOCTOREMPLOYEENOTE", data.data.doctor.code);
              let toChatFlag = false;
              let toPrescriptionsFlag = false;
              data.data.permissions.forEach((item) => {
                switch (item.name) {
                  case "预约问诊":
                    toChatFlag = true;
                    break;
                  case "处方记录":
                    toPrescriptionsFlag = true;
                }
              });
              if (data.data.doctor.type == 2) {
                this.$router.push("/prescriptions");
              } else {
                this.$router.push("/chat");
              }
            }
          } else {
            this.outFlag = true;
            this.errorMsg = data.msg;
            this.QR_code_loading = false;
            setTimeout(() => {
              this.outFlag = false;
            }, 3000);
            this.get_CA_Token();
          }
        });
      }, 5000);
    },
    captchaLoad() {
      getCaptcha().then((res) => {
        if (res.code === 0) {
          this.captchaImg = res.data.data;
          this.loginForm.uuid = res.data.uuid;
        } else {
          this.outFlag = true;
          this.errorMsg = res.msg;
          setTimeout(() => {
            this.outFlag = false;
          }, 3000);
        }
      });
    },
    LoginButton() {
      this.loginLoadingFlag = true;
      var _this = this;
      let postData = {
        username: this.loginForm.username,
        password: encrypt(this.loginForm.password),
        uuid: this.loginForm.uuid,
        code: this.loginForm.code
      }
      Login(postData)
          .then((res) => {
            if (res.code === 0) {
              this.$message({
                message: "登录成功",
                type: "success",
              });
              localStorage.setItem("token", res.data.token);
              socketInit();
              localStorage.setItem("doctor", JSON.stringify(res.data.doctor));
              localStorage.setItem("doctorEmployee", res.data.doctor.code);
              localStorage.setItem("doctorName", res.data.doctor.name);
              localStorage.setItem("doctorType", res.data.doctor.type);
              localStorage.setItem("hospitalCode", res.data.doctor.hospitalCode);
              localStorage.setItem(
                  "permissions",
                  JSON.stringify(res.data.permissions)
              );
              store.commit("SET_DOCTOREMPLOYEENOTE", res.data.doctor.code);
              let toChatFlag = false;
              let toPrescriptionsFlag = false;
              res.data.permissions.forEach((item) => {
                switch (item.name) {
                  case "预约问诊":
                    toChatFlag = true;
                    break;
                  case "处方记录":
                    toPrescriptionsFlag = true;
                }
              });
              if (res.data.doctor.type == 2) {
                this.$router.push("/prescriptions");
              } else {
                this.$router.push("/chat");
              }
            } else {
              this.outFlag = true;
              this.errorMsg = res.msg;
              this.loginForm.code = "";
              this.captchaLoad();
              setTimeout(() => {
                this.outFlag = false;
              }, 2000);
            }
            this.loginLoadingFlag = false;
          })
      setTimeout(() => {
        _this.loginLoadingFlag = false;
      }, 2000);
    },
    changeLoginButton() {
      this.loginFormFLag = !this.loginFormFLag;
      if (this.loginFormFLag) {
        this.buttonName = "切换为账号密码登录=>";
        this.getQR_code();
        this.get_CA_Token();
      } else {
        clearTimeout(this.CA_Login_timer);
        clearInterval(this.getCA_Token_timer);
        this.buttonName = "切换为医网信登录=>";
        this.captchaLoad()
      }
    },
    changInputType() {
      if (this.showPassword == false) {
        this.showPassword = true;
        this.inputType = "txt";
      } else {
        this.showPassword = false;
        this.inputType = "password";
      }
    },
  },
  created() {
    this.getCaFlag();
  },
  mounted() {
    localStorage.removeItem("token");
    localStorage.removeItem("doctorName");
    localStorage.removeItem("doctorEmployee");
    localStorage.removeItem("permissions");
  },
  beforeDestroy() {
    clearTimeout(this.CA_Login_timer);
    clearInterval(this.getCA_Token_timer);
  },
};
</script>
<style scoped>
.login-wrap {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background: #0caf60;
  background-size: 100% 100%;
}

.left {
  position: relative;
  width: 50%;
  height: 100%;
}

.left img {
  position: absolute;
  top: 8rem;
  left: 24rem;
  width: 42rem;
  height: 45rem;
  z-index: 1;
}

.right {
  position: relative;
  border-radius: 24px 0px 0px 24px;
//width: 50%; height: 100%; background: #fff; z-index: 0;
}

.loginBox .LOGO {
  margin-bottom: 40px;
  width: 180px;
  height: 40px;
  background: #0caf60;
}

.loginBox {
  padding: 16rem 160px 0px 178px;
}

.right /deep/ input {
  border-radius: 14px;
  border: 0px;
  height: 54px;
  background: #fafafa;
}

.right /deep/ input:focus {
  background: #fff;
  border: 1px solid #0caf60;
}

.loginTitle {
  margin-bottom: 46px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
}

.loginButton {
  margin-top: 40px;
  margin-bottom: 40px;
  display: block;
  border: 0px;
  border-radius: 12px;
  height: 58px;
  width: 100%;
  background: #0caf60;
  color: #fff;
  outline: none;
}

.loginButton:active {
  outline: none;
  border: 0px;
  background: #86d6af;
}

.captcha {
  position: absolute;
  top: 8.5px;
  right: 15px;
  width: 76px;
  height: 37px;
  cursor: pointer;
}

.passwordBox {
  position: relative;
}

.passwordBox i {
  position: absolute;
  top: 8px;
  right: 14px;
  font-size: 30px;
  color: #a0aec0;
  cursor: pointer;
}

.changeButton /deep/ .el-button {
  display: block;
  margin: 0 auto;
}

.tipsMsgBox /deep/ .el-dialog__header {
  display: none;
}

.tipsMsgBox /deep/ .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

/* Microsoft Edge 适配 */
.changeButton .el-button {
  display: block;
  margin: 0 auto;
}

.tipsMsgBox .el-dialog__header {
  display: none;
}

.tipsMsgBox .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.QRcodeBox div:first-child {
  text-align: center;
  margin-bottom: 8px;
}

.QRcodeBox img {
  display: block;
  margin: 0 auto;
  width: 180px;
  height: 180px;
  cursor: pointer;
}

@media only screen and (max-height: 617px) {
  .loginBox {
    padding: 0;
  }

  .left img {
    position: absolute;
    top: 5rem;
    left: 20rem;
    width: 28rem;
    height: 30rem;
    z-index: 1;
  }
}

@media only screen and (max-height: 550px) {
  .loginBox {
    padding: 0;
  }

  .loginTitle {
    margin-bottom: 22px;
    font-size: 24px;
  }

  .left img {
    position: absolute;
    top: 1rem;
    left: 20rem;
    width: 28rem;
    height: 30rem;
    z-index: 1;
  }

  .loginButton {
    margin: 20px auto;
  }
}

@media only screen and (max-width: 1366px) {
  .loginBox {
    padding: 6rem 160px 0px 178px;
  }
}

@media only screen and (max-width: 1000px) {
  .loginBox {
    padding: 0;
  }
}
</style>
